(function () {
  const selector = '[data-sd-category-slider]';

  class SDCategorySlider {
    constructor(element) {
      if (element.dataset.sliderInitialized === 'true') return;

      this.element = element;
      this.viewport = element.querySelector('[data-slider-viewport]');
      this.slides = Array.from(element.querySelectorAll('[data-slider-slide]'));
      this.previousButton = element.querySelector('[data-slider-previous]');
      this.nextButton = element.querySelector('[data-slider-next]');
      this.dotsContainer = element.querySelector('[data-slider-dots]');
      this.status = element.querySelector('[data-slider-status]');
      this.pageStarts = [];
      this.currentPage = 0;
      this.scrollFrame = null;

      if (!this.viewport || this.slides.length === 0) return;

      element.dataset.sliderInitialized = 'true';
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.previousButton?.addEventListener('click', () => this.goToPage(this.currentPage - 1));
      this.nextButton?.addEventListener('click', () => this.goToPage(this.currentPage + 1));
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.viewport);
      this.rebuild();
    }

    getItemsPerPage() {
      if (window.matchMedia('(min-width: 990px)').matches) return 3;
      if (window.matchMedia('(min-width: 750px)').matches) return 2;
      return 1;
    }

    rebuild() {
      const itemsPerPage = this.getItemsPerPage();
      this.pageStarts = [];
      for (let index = 0; index < this.slides.length; index += itemsPerPage) {
        this.pageStarts.push(index);
      }
      this.renderDots();
      this.updateCurrentPage();
    }

    renderDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.replaceChildren();
      this.pageStarts.forEach((slideIndex, pageIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sd-category-slider__dot';
        dot.setAttribute('aria-label', `Kategorienseite ${pageIndex + 1} von ${this.pageStarts.length}`);
        dot.addEventListener('click', () => this.goToPage(pageIndex));
        this.dotsContainer.appendChild(dot);
      });
    }

    goToPage(pageIndex) {
      const boundedPage = Math.max(0, Math.min(pageIndex, this.pageStarts.length - 1));
      const target = this.slides[this.pageStarts[boundedPage]];
      if (!target) return;

      const firstSlideOffset = this.slides[0].offsetLeft;
      this.viewport.scrollTo({ left: target.offsetLeft - firstSlideOffset, behavior: 'smooth' });
    }

    updateCurrentPage() {
      const scrollLeft = this.viewport.scrollLeft;
      const maximumScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      let closestPage = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      if (maximumScroll > 0 && Math.abs(maximumScroll - scrollLeft) < 2) {
        closestPage = this.pageStarts.length - 1;
      } else {
        const firstSlideOffset = this.slides[0].offsetLeft;
        this.pageStarts.forEach((slideIndex, pageIndex) => {
          const slidePosition = this.slides[slideIndex].offsetLeft - firstSlideOffset;
          const distance = Math.abs(slidePosition - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPage = pageIndex;
          }
        });
      }

      const changed = closestPage !== this.currentPage;
      this.currentPage = closestPage;
      if (this.previousButton) this.previousButton.disabled = this.currentPage === 0;
      if (this.nextButton) this.nextButton.disabled = this.currentPage === this.pageStarts.length - 1;

      this.dotsContainer?.querySelectorAll('.sd-category-slider__dot').forEach((dot, index) => {
        if (index === this.currentPage) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      if (changed && this.status) {
        this.status.textContent = `Kategorienseite ${this.currentPage + 1} von ${this.pageStarts.length}`;
      }
    }

    onScroll() {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.updateCurrentPage());
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => this.rebuild(), 100);
    }
  }

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((element) => new SDCategorySlider(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
